import React from 'react';

import { StyledOrderSummary } from './OrderSummary.styles';

import { OrderSummaryProps } from './OrderSummary.types';

const OrderSummary = ({
  headerSlot,
  contentSlot,
  footerSlot,
  componentClassname = 'order-summary',
  customClassnames = '',
  customStyle = '',
  ...props
}: OrderSummaryProps) => {
  return (
    <StyledOrderSummary
      {...props}
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {headerSlot && (
        <header className={`${componentClassname}__header`}>
          {headerSlot}
        </header>
      )}

      {contentSlot && (
        <main className={`${componentClassname}__content`}>{contentSlot}</main>
      )}

      {footerSlot && (
        <footer className={`${componentClassname}__footer`}>
          {footerSlot}
        </footer>
      )}
    </StyledOrderSummary>
  );
};
OrderSummary.displayName = 'OrderSummary';

export default OrderSummary;
